import { useCallback, useEffect, useState } from 'react';

const useScrollFlag = (threshold) => {
  const [flag, setFlag] = useState(false);
  const onScroll = useCallback(() => setFlag(window.scrollY > threshold), [threshold, setFlag]);
  useEffect(() => {
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);
  return flag;
};

export default useScrollFlag;
